import { Article } from "@/types/models";
import contentTypes from "@/view/constants/contentTypes";

export function isArticle(data: any): data is Article {
  return data && (data as Article).content_type === contentTypes.ARTICLE;
}
